const defaultKeyboardFocusClass = 'keyboard-focus';
const keyboardFocusEnabledClass = 'keyboard-focus-enabled';
const focusModalityStateKey = '__inviaFocusModalityState';

const getFocusModalityState = () => {
	if (!window[focusModalityStateKey]) {
		window[focusModalityStateKey] = {
			initialized: false,
			keyboardFocusClasses: new Set([defaultKeyboardFocusClass]),
		};
	}

	return window[focusModalityStateKey];
};

export const initFocusModality = (options = {}) => {
	const root = document.documentElement;
	const state = getFocusModalityState();
	const classesToAdd = Array.isArray(options.keyboardFocusClasses) && options.keyboardFocusClasses.length > 0
		? options.keyboardFocusClasses
		: [defaultKeyboardFocusClass];

	const hadKeyboardFocusClass = Array.from(state.keyboardFocusClasses).some((focusClass) =>
		root.classList.contains(focusClass),
	);

	classesToAdd.forEach((focusClass) => state.keyboardFocusClasses.add(focusClass));
	root.classList.add(keyboardFocusEnabledClass);

	if (state.initialized) {
		if (hadKeyboardFocusClass) {
			classesToAdd.forEach((focusClass) => root.classList.add(focusClass));
		}
		return;
	}

	state.initialized = true;

	const handlePointerInteraction = () => {
		state.keyboardFocusClasses.forEach((focusClass) => root.classList.remove(focusClass));
	};

	const handleKeyboardInteraction = (event) => {
		if (event.key === 'Tab') {
			state.keyboardFocusClasses.forEach((focusClass) => root.classList.add(focusClass));
		}
	};

	document.addEventListener('keydown', handleKeyboardInteraction, true);
	document.addEventListener('pointerdown', handlePointerInteraction, true);
	document.addEventListener('mousedown', handlePointerInteraction, true);
	document.addEventListener('touchstart', handlePointerInteraction, true);
};
